import { z } from 'zod';

export const FORM_SCHEMA = z.object({
  email: z
    .string()
    .email('Invalid email address')
    .min(1, 'Required'),
  retailer_id: z.string().min(1, 'Please choose a store')
});
